import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as classnames from 'classnames';
import { responseLogWithNotification } from '../../../utils/utils';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import Loader from '../../../components/base/Loader/Loader';
import { Alert, Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { hideSignPopup, loadCadesStore } from '../actions';
import Grid from '../../../components/base/Grid/Grid';
import { getCadesData } from '../reducer';
import { dateTimeFormatter } from '../../../utils/formatters';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

export default function SignPopup() {
  const dispatch = useDispatch();
  const [selectedCert, setSelectedCert] = useState(-1);
  const {
    showSignPopup = false,
    cadesCertificates,
    loadingCadesCertificates,
    cadesState,
    loadingSignDocument,
    signPromiseId = null,
  } = useSelector(getCadesData);

  useEffect(() => {
    if (showSignPopup) {
      dispatch(loadCadesStore()).catch(responseLogWithNotification);
    }
  }, [showSignPopup]);

  if (!showSignPopup) {
    return null;
  }

  const hide = () => {
    rejectActionPromise({ promiseId: signPromiseId })();
    dispatch(hideSignPopup());
  };

  const signFiles = () => {
    resolveActionPromise({ promiseId: signPromiseId }, cadesCertificates[selectedCert])();
    dispatch(hideSignPopup());
  };

  const onSelectRow = (item, event, index) => setSelectedCert(index === selectedCert ? -1 : index);

  const columnTooltipFormatter = a => <Tooltip content={a} className={classnames('column-tooltip c300')} />;

  const columns = [
    {
      dataField: 'cn',
      text: 'Имя сертификата',
      formatter: columnTooltipFormatter,
    },
    // {
    //   dataField: 'direction',
    //   text: 'Подразделение',
    //   formatter: columnTooltipFormatter,
    // },
    {
      dataField: 'email',
      text: 'Email',
      formatter: columnTooltipFormatter,
    },
    {
      dataField: 'issuerInfo',
      text: 'Выдан',
      formatter: columnTooltipFormatter,
    },
    {
      dataField: 'certFromDate',
      text: 'Дата получения',
      formatter: dateTimeFormatter,
      headerClassName: 'date-with-time',
    },
    {
      dataField: 'certToDate',
      text: 'Дата окончания',
      formatter: dateTimeFormatter,
      headerClassName: 'date-with-time',
    },
  ];

  return (
    <Dialog
      onClose={hide}
      open={showSignPopup}
      className="sign-popup"
      size="xl"
    >
      <DialogTitle header="Выбор сертификата подписи" title={<Icons onClick={hide} customIcon icon="close" className="close" />} />
      <DialogContent>
        <div className="sign-certificates-block">
          <Loader loading={!cadesState || loadingCadesCertificates} />
          {cadesState && cadesState.isError ? <Alert variant="danger">Ошибка: {cadesState.errorText}</Alert> : null}
          <Grid
            className="list"
            data={cadesCertificates}
            columns={columns}
            onClickByRow={onSelectRow}
            rowClassFormatter={(_, index) => (index === selectedCert ? 'clickable-table-row selected' : 'clickable-table-row')}
          />
        </div>
      </DialogContent>
      <DialogFooter className="modal-buttons">
        <Button variant="secondary" className="back" onClick={hide}>Отменить</Button>
        <Button
          disabled={!cadesState || cadesState.isError || selectedCert < 0}
          onClick={signFiles}
        >
          Подписать
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
